export default __webpack_public_path__ + "static/media/photo--sm--36.69d76508.jpg";